interface EmailSubscriptionFeatureToggles {
  journalFooterForm: boolean
  datingFooterForm: boolean
  journalPopUp: boolean
  datingPopUp: boolean
  journalPopUpDelay: number
  datingPopUpDelay: number
}

interface SmartBannerFeatureToggles {
  redisplayIntervalJournal: number
  redisplayIntervalDating: number
}

export interface FeatureTogglesSerializerOutput {
  emailSubscription?: EmailSubscriptionFeatureToggles
  smartBanner?: SmartBannerFeatureToggles
}

export const FEATURE_TOGGLES_PRESET: FeatureTogglesSerializerOutput = {
  emailSubscription: {
    journalFooterForm: false,
    datingFooterForm: false,
    journalPopUp: false,
    datingPopUp: false,
    journalPopUpDelay: 30,
    datingPopUpDelay: 30,
  },
  smartBanner: {
    redisplayIntervalJournal: 30,
    redisplayIntervalDating: 30,
  },
}

interface FeatureTogglesSerializerInput {
  EmailSubscription: {
    JournalFooterForm: boolean
    DatingFooterForm: boolean
    JournalPopUp: boolean
    DatingPopUp: boolean
    JournalPopUpDelay: number
    DatingPopUpDelay: number
  }
  SmartBanner?: {
    redisplay_interval_journal: number
    redisplay_interval_dating: number
  }
}

export function FeatureTogglesSerializer({
  EmailSubscription,
  SmartBanner,
}: FeatureTogglesSerializerInput): FeatureTogglesSerializerOutput {
  return {
    emailSubscription: {
      journalFooterForm: EmailSubscription.JournalFooterForm,
      datingFooterForm: EmailSubscription.DatingFooterForm,
      journalPopUp: EmailSubscription.JournalPopUp,
      datingPopUp: EmailSubscription.DatingPopUp,
      journalPopUpDelay: EmailSubscription.JournalPopUpDelay,
      datingPopUpDelay: EmailSubscription.DatingPopUpDelay,
    },
    smartBanner: {
      redisplayIntervalJournal: SmartBanner?.redisplay_interval_journal || 30,
      redisplayIntervalDating: SmartBanner?.redisplay_interval_dating || 30,
    },
  }
}
